import { RootState } from 'store/index';
import createResourceListSelectors from 'store/ResourceListSelectors';
import { CustomerState, ResourceListSelectors } from 'typings/state';

const selectors: ResourceListSelectors = createResourceListSelectors(
    (state: RootState): CustomerState => state.customer,
);

export default selectors;
